<template>
	<div class="usePageBox">
		<div class="topBox">
			<div class="leftBox">
				<AutoComplete size="large" placeholder="输入商品名搜索" icon="ios-search" clearable
				              @on-search="searchSkuNameCallback" @on-select="selectSkuNameCallback">
					<Option v-for="item in searchSkuList" :value="item.sku_name" :key="item.sku_id">
						{{ item.sku_name }}
					</Option>
				</AutoComplete>
			</div>
			<div class="leftBox">
				<Select placeholder="请选择分类" size="large" clearable v-model="searchParams.skuCategoryId"
				        @on-change="searchSkuCategoryCallback">
					<Option v-for="item in skuCategoryList" :value="item.id" :key="item.id" :label="item.title">
						<span>{{ item.title }}</span>
					</Option>
				</Select>
			</div>
			<div class="leftBox">
				<Dropdown trigger="custom" :visible="showSelectDate" @on-clickoutside="showSelectDate = false">
					<div @click="toShowSelectDate">
						<Input style="width:140px;" readonly size="large" v-model="showNowSelectDate" icon="ios-arrow-down"
						       placeholder="请选择生成时间"/>
					</div>
					<DropdownMenu slot="list">
						<Row :gutter="12" style="width: 600px;height: 540px;">
							<Col span="24" style="padding: 8px 20px 0px 10px;">
								<div
									style="padding:0 20px;box-sizing:border-box; height: 60px;border: 1px solid #e4e7ed;display:flex;align-items:center;justify-content: space-between;">
									<div style="display:flex;align-items:center;">
										<b>当前选择：</b>
										<b>{{ nowSelectDate }}</b>
									</div>
									<Button @click="changeDateCallback()" style="height:40px;" type="default">清除选择</Button>
								</div>
								<eleCalendar :data="[]" prop="date" :render-content="renderContent" :currentmonth="true"
								             :highlight="true" selectionMode="day" :border="true" @pick="changeDateCallback"/>
							</Col>
						</Row>
					</DropdownMenu>
				</Dropdown>
				<!-- @click="toShowSelectDate" -->
				<!--  -->
			</div>
			<div class="rightBox">
				<div>
					<span>图片分拣</span>
					<i-switch size="large" v-model="openPic" @on-change="changeOpenSkuCover">
						<span slot="open">开</span>
						<span slot="close">关</span>
					</i-switch>
				</div>
				<div v-if="$store.state.preSortingType == 2">
          <span style="right: 0px;">
            <a @click="showSearch">更多筛选<Icon type="ios-arrow-forward"/></a>
          </span>
				</div>
			</div>
		</div>
		<div class="contentBox">
			<div class="leftBox">
				<div class="skuBoxArea" style="width:240px;height:100%;overflow:hidden; overflow-y:scroll;background:white">
					<div class="skuBox">
						<div @click="toSelect(item)" :class="currentSku.groupSkuId == item.groupSkuId ? 'active' : ''"
						     v-for="item in skuList" :key="item.id" class="skuItem">
							<div class="textBox" style="font-size:20px" :id="'text' + item.sku_id">
								{{ item.sku_name ? item.sku_name : item.product_name }}
								<div class="countNum" v-if="item.wait_count > 0">
									<div class="numtext">{{ item.wait_count }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="rightBox">
				<Row>
					<Col style="height:78vh;" :flex="1">
						<Spin fix v-if="loading">
							<Icon type="ios-loading" size="18" class="demo-spin-icon-load"/>
							<div>Loading</div>
						</Spin>
						<batchNumberModel @callBackData="callBackData" :batchCountObj="batchCountObj" ref="batchNumberRef"/>
						<!-- 溯源-分拣绑定入库批次 -->
						<Row :gutter="20" v-if="!loading">
							<div class="conentTop">
								<div class="weightBox">
									<div class="weightleft">
										<div class="weightValue">
											{{ currentWeightData }}
											<template v-if="currentSku.is_weight==1">{{ currentSku.base_unit }}</template>
											<template v-else>{{ currentSku.auxiliary_unit }}</template>
										</div>
										<div class="signValue">{{showSignValue}}</div>
									</div>
									<div v-if="currentSku.is_weight==1" @click="toCreateSortTag()" class="weightright">
										定重
									</div>
								</div>
								<div class="operationBox">
									<div class="operationButton" @click="showKeyboard(1)">
										<span v-if="currentSku.is_weight==1">手工定重</span>
										<span v-else>手工定量</span>
									</div>
									<div class="operationButton" @click="showBatchCreate = true" style="margin-top:10px;">
										批量生成
									</div>
								</div>
							</div>
							<div class="dataInfoBox">
								<div v-if="$store.state.preSortingType == 2" class="dataInfo">
									需打包数：<a @click="queryPreSortingDetailBySku()">{{ preSortingData.allNeedPackNumber }}</a>
								</div>
								<div class="dataInfo">已打包总数：{{ preSortingData.allHadPackNumber }}</div>
								<div class="dataInfo">已打包未分拣：{{ preSortingData.waitSortPackNumber }}</div>
								<div class="dataInfo">已分拣：{{ preSortingData.sortPackNumber }}</div>
							</div>
							<div class="tabItems" :class="{short:skuBatchNoList.length}">
								<Row style="width:100%;">
									<Col :sm="24" :md="12" :lg="12" :xl="8" :xxl="8" v-for="item in tagsList" style="margin-bottom:20px;"
									     :key="item.id">
										<div class="tabItem">
											<div class="itemBox" :class="{hadBind: item.status == CONSTANT.PRESORTING_STATUS.BIND}">
												<div class="itemLeft">
													<!-- <div class="itemCode">编码：SPNEJKMN</div> -->
													<div class="itemCode">编号：P{{ item.id }}</div>
													<div class="itemValue"> {{ item.showUnitNumer }}</div>
													<div v-if="item.status == CONSTANT.PRESORTING_STATUS.BIND" class="itemStatus">
														已分拣：{{item.inner_no}}
													</div>
													<div v-if="item.status == CONSTANT.PRESORTING_STATUS.UNBIND" class="itemStatus">
														未分拣
													</div>
												</div>
												<div class="itemRight">
													<div @click="toPrint([item.id])" class="operationButton">
														打印
													</div>
													<div v-if="item.status == CONSTANT.PRESORTING_STATUS.UNBIND"
													     @click="toDel(item)" class="operationButton">
														删除
													</div>
												</div>
											</div>
											<div class="turnBoxArea" style="font-size:16px;margin-top:10px;"
											     v-if="item.box_setting&&item.box_setting.selectBoxList&&item.box_setting.selectBoxList.length">
												周转物：
												<span style="font-size:16px;color:#2D8cF0;" v-for="(box,index) in item.box_setting.selectBoxList"
												      :key="index">
                          {{box.title}}*{{box.count}}
                        </span>
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</Row>
						<div style="height: 50px;"/>
					</Col>
				</Row>
			</div>
		</div>
		<search ref="search" :searchParams="searchParams" :carLine="carLine" @reciveSearchData="reciveSearchData"
		        v-if="$store.state.preSortingType == 2"/>
		<keyboard ref="keyboard" @reciveData="reciveKeyboardData" :canDecimal="canDecimal"/>
		<keyboard ref="keyboard2" @reciveData="reciveKeyboardDataTwo" :canDecimal="false"/>
		<weightReading :showWeight="false" @reciveData="reciveData" ref="weightReading"/>
		<picModal v-if="openPic" ref="picModal" :skuId="currentSku.groupSkuId"/>
		<Modal title="批量生成" v-model="showBatchCreate" width="600px;" :footer-hide="true">
			<div class="batchCreateBox">
				<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="140">
					<FormItem prop="weight">
						<span slot="label">数量：</span>
						<Input style="width:200px;" size="large" readonly type="number" @on-focus="showKeyboard(2)"
						       v-model="formValidate.weight"/>
						<span v-if="currentSku.is_weight==1">{{ currentSku.base_unit }}</span>
						<span v-else>{{ currentSku.auxiliary_unit }}</span>
					</FormItem>
					<FormItem @click="showKeyboardTwo" prop="number">
						<span slot="label">打印标签数：</span>
						<Input style="width:200px;" size="large" readonly type="number" @on-focus="showKeyboardTwo"
						       v-model="formValidate.number"/>
					</FormItem>
				</Form>
				<div class="bottomBox">
					<div @click="showBatchCreate = false" class="bottomButton">取消</div>
					<div @click="toCreateBatchSortTag" class="bottomButton mk">确定</div>
				</div>
			</div>
		</Modal>
		<!--条形码-->
		<img id="jsbarcode" v-show="false"/>
		<globalPrint ref="globalPrint"/>
		<Modal v-model="showWarningBox" width="500">
			<p slot="header" style="color:#f60;text-align:center">
				<Icon type="ios-information-circle"/>
				<span>分拣提示</span>
			</p>
			<div style="display:flex;align-items:center;justify-content: center; height:200px;">
				<p>{{signText}}</p>
			</div>
			<div slot="footer">
				<div class="footerButton" @click="showWarningBox=false">取消分拣</div>
				<div class="footerButton waring" @click="toStillDo">继续分拣</div>
				<div class="footerButton success" v-if="signType==1" @click="toChangeDo()">切换批次分拣</div>
				<div class="footerButton success" v-if="signType==2" @click="toChooseNoneDo">无批次分拣</div>
			</div>
		</Modal>

		<!--需打包数量-详情-->
		<PreSortingDetail ref="preSortingDetail"></PreSortingDetail>
	</div>
</template>

<script>
	import config from "@/config";

	const h5PageUrl = process.env.NODE_ENV === "development" ? config.baseUrl.h5PageDev : config.baseUrl.h5PagePro;
	const CONSTANT = require("../../../common/const");
	const timeUtil = require("@/libs/timeUtil");
	const JsBarcode = require("jsbarcode");
	import {changeUnit,getHasSortingUnitAndBaseUnit} from "@/libs/util";
	import keyboard from "_c/keyboard";
	import batchNumberModel from "_c/batchNumberModel"
	import eleCalendar from "ele-calendar";
	import weightReading from "_c/weightReading";
	import picModal from "_c/picModal";
	import {querySkuCategory, queryCarLine} from "@/api/sorting/sorting";
	import PreSortingDetail from "./preSortingDetail.vue";
	import {
		queryPreSortingSkuType1, queryPreSortingSkuType2, queryPreSortingBySku,
		createPrePack, deletePrePack
	} from "@/api/sorting/preSorting";
	import {getBackgroundColor} from "@/libs/tools";

	export default {
		name: "preSorting",
		components: {keyboard, weightReading, picModal, eleCalendar, batchNumberModel, PreSortingDetail},
		data() {
			return {
				doType: 1,
				doWeight: '',
				nowIndex: '',
				nowBatch_no: '',
				canUseBatchs: [],
				realCanDo: false,
				showWarningBox: false,
				signText: '',
				signType: 1,
				batchCountObj: {},
				skuBatchNoList: [], // sku列表，数据结构:[{skuId,batch_nos:批次号数组}]
				batchNoSelect: [],  // 当前选择批次数组，与sku一一对应


				showSignValue: '',
				nowSelectDate: "",
				showNowSelectDate: "",
				showSelectDate: false,
				tagsList: [],
				ruleValidate: {
					weight: [{
						required: true, message: "请输入数量", trigger: "change", validator: (rule, value, callback) => {
							if (value <= 0) {
								callback(new Error("数量必须大于零"));
							} else {
								callback();
							}
						}
					}],
					number: [{
						required: true, message: "请输入生成数量", trigger: "change", validator: (rule, value, callback) => {
							if (value <= 0) {
								callback(new Error("打印标签数必须大于零"));
							} else {
								callback();
							}
						}
					}]
				},
				formValidate: {weight: 1, number: 1},
				preSortingData: {},

				flush: true, // 处理数据不刷新
				CONSTANT,
				getBackgroundColor,
				workbenchId: 0, // 工作台id
				loading: true,
				// 分拣sku列表
				skuList: [],
				// 检索sku列表
				searchSkuList: [],
				// 当前选中sku
				currentSku: {},
				// 当前选择分拣数据
				currentSortingData: {},
				// SKU分类列表
				skuCategoryList: [],
				// 查询参数
				searchParams: {
					lineId: null,
					distributor: null,
					supplierId: null,
					packingType: null,
					skuCategoryId: null,
					dateType: this.$store.state.dateType
				},
				// 拣货数据
				packDatas: [],
				// 开启图片分拣
				openPic: false,
				// 配送路线
				carLine: [],
				// 当前电子秤读数、输入数量
				currentWeightData: 0,
				// 小票模板
				printTemplate: {},
				sortingNoData: {}, // 分拣序号数据
				// 电子秤读数接收完成
				reciveWeightComplete: false,
				// 展示批量生成区域
				showBatchCreate: false,
        // 1手工定重 2批量生成
				keyBorderValue: 1,
			};
		},
		computed: {
			canDecimal() {
				let canDo = true;
				if (this.currentSku.is_weight == 1) {
					canDo = true;
				} else {
					canDo = false;
				}
				return canDo;
			}
		},
		methods: {
			callBackData(data) {
				this.batchNoSelect = data.batchNoSelect;
				this.skuBatchNoList = data.skuBatchNoList;
			},
			countBatchCount() {
				this.batchCountObj = {};
				for (let i = 0; i < this.tagsList.length; i++) {
					let packItem = this.tagsList[i];
          // console.log("库存批次", packItem)
					if (packItem.batch_no) {
						if (packItem.is_weight == 1) {
							if (this.batchCountObj[packItem.batch_no]) {
								let realCount = Number(this.batchCountObj[packItem.batch_no]) + Number(packItem.weight / 500)
								this.$set(this.batchCountObj, packItem.batch_no, realCount)
							} else {
								this.$set(this.batchCountObj, packItem.batch_no, Number(packItem.weight / 500))
							}
						} else {
							if (this.batchCountObj[packItem.batch_no]) {
								let realCount = Number(this.batchCountObj[packItem.batch_no]) + Number(packItem.pack_count)
								this.$set(this.batchCountObj, packItem.batch_no, realCount)
							} else {
								this.$set(this.batchCountObj, packItem.batch_no, Number(packItem.pack_count))
							}
						}
					}
				}
			},
			toShowSelectDate() {
				this.showSelectDate = true;
			},
			changeDateCallback(date, event, row, dom) {
				if (date) {
					this.nowSelectDate = timeUtil.dateFormat(date, "YYYY-MM-DD");
					this.showNowSelectDate = timeUtil.dateFormat(date, "M月DD日");
				} else {
					this.nowSelectDate = "";
					this.showNowSelectDate = "";
				}
				this.showSelectDate = false;
				// TODO 查询预分拣数据
				this.queryPreSortingBySku();
			},
			renderContent(h, parmas) {
				const loop = data => {
					return data.defvalue.value ? (
						<div>
							<div style="font-size:20px;">{data.defvalue.text}</div>
						</div>
					) : (
						<div style="font-size:20px;">{data.defvalue.text}</div>
					);
				};
				return (
					<div style="min-height:60px;">
						<b>{loop(parmas)}</b>
					</div>
				);
			},
			// 删除
			toDel(item) {
				this.$Modal.confirm({
					title: "确认删除",
					content: "<p>删除后将无法恢复，确认删除?</p>",
					onOk: () => {
						deletePrePack({id: item.id}).then(data => {
							if (data.data.code == 1200) {
								this.$Message.success("删除成功");
								this.queryPreSortingBySku();
							} else {
								this.$Message.error(data.data.msg);
							}
						}).catch(err => {
							this.$Message.error(err);
						});
					}
				});
			},
			// 打印
			toPrint(preSortingIds) {
				this.$refs.globalPrint.printPreSorting(preSortingIds);
			},
			// 创建
			toCreateSortTag(weight) {
				let that = this;
				that.doType = 1;
				that.doWeight = weight ? weight : 0;
				if (!that.currentSku || !that.currentSku.sku_id) {
					return
				}
				let preWeight = weight ? weight : that.currentWeightData;
				if (preWeight <= 0) {
					return
				}
				if (!this.judgeBatchStoreNumer(preWeight)) {
					if (!this.realCanDo) {
						return
					}
				}
				this.realCanDo = false;

				let params = {skuId: that.currentSku.sku_id};
				if (this.$store.state.boxSetting && this.$store.state.boxSetting.selectBoxList.length) {
					params.boxSetting = this.$store.state.boxSetting;
				}
				if (that.currentSku.is_weight == 1) {
					params.weight = changeUnit(preWeight, that.currentSku.base_unit, "g");
				} else {
					params.weight = preWeight;
				}

				if (this.nowSelectDate) {
					params.date = this.nowSelectDate;
				}

				for (let i = 0; i < this.skuBatchNoList.length; i++) {
					if (this.skuBatchNoList[i].skuId == this.currentSku.sku_id) {
						params.batch_no = this.batchNoSelect[i];
					}
				}
				createPrePack(params).then(data => {
					if (data.data.code == 1200) {
						this.$Message.success("创建成功");
						this.queryPreSortingBySku();
						// 打印标签
						this.toPrint(data.data.data.createIds);
					} else {
						this.$Message.error(data.data.msg);
					}
				}).catch(err => {
					this.$Message.error(err);
				});
			},
			// 批量创建
			toCreateBatchSortTag() {
				let that = this;
				that.doType = 2;
				if (!that.currentSku || !that.currentSku.sku_id) {
					return
				}
				this.$refs.formValidate.validate(valid => {
					if (valid) {
						let preWeight = that.formValidate.weight;
						// let preWeight = changeUnit(that.formValidate.weight, that.currentSku.base_unit, "g");
						if (preWeight <= 0) {
							return
						}
						if (!this.judgeBatchStoreNumer(preWeight * that.formValidate.number)) {
							if (!this.realCanDo) {
								return
							}
						}
						this.realCanDo = false;

						let params = {skuId: that.currentSku.sku_id, pack_count: that.formValidate.number};
						if (that.currentSku.is_weight == 1) {
							params.weight = changeUnit(preWeight, that.currentSku.base_unit, "g");
						} else {
							params.weight = preWeight;
						}
						if (this.nowSelectDate) {
							params.date = this.nowSelectDate;
						}
						for (let i = 0; i < this.skuBatchNoList.length; i++) {
							if (this.skuBatchNoList[i].skuId == this.currentSku.sku_id) {
								params.batch_no = this.batchNoSelect[i];
							}
						}
						createPrePack(params).then(data => {
							if (data.data.code == 1200) {
								this.$Message.success("创建成功");
								this.queryPreSortingBySku();
								this.showBatchCreate = false;
								// 打印标签
								this.toPrint(data.data.data.createIds);
							} else {
								this.$Message.error(data.data.msg);
							}
						}).catch(err => {
							this.$Message.error(err);
						});
					} else {
						this.$Message.error();
					}
				});
			},
			judgeBatchStoreNumer(weight) {
				let that = this;
				let canDo = true;
				let realWeight = weight;
				let batch_no = '';
				let batch_number = 0;
				let canUseBatchs = [];
				let nowIndex = '';
				for (let i = 0; i < this.skuBatchNoList.length; i++) {
					if (this.skuBatchNoList[i].skuId == this.currentSku.sku_id) {
						batch_no = this.batchNoSelect[i];
						for (let k = 0; k < this.skuBatchNoList[i].batch_nos.length; k++) {
							let hadUseNum = that.batchCountObj[this.skuBatchNoList[i].batch_nos[k].batch_no] ? that.batchCountObj[this.skuBatchNoList[i].batch_nos[k].batch_no] : 0;
							let nowNumber = this.skuBatchNoList[i].batch_nos[k].number;
							let canUseNum = nowNumber - hadUseNum;
							if (realWeight <= canUseNum) {
								canUseBatchs.push({index: i, batch_no: this.skuBatchNoList[i].batch_nos[k].batch_no})
							}
							if (this.skuBatchNoList[i].batch_nos[k].batch_no == batch_no) {
								batch_number = this.skuBatchNoList[i].batch_nos[k].number;
								nowIndex = i;
							}
						}
					}
				}
				this.canUseBatchs = canUseBatchs;
				// 存下批次分拣
				if (batch_no) {
					// 判断本批次的库存是否足够
					let hadUseNum = that.batchCountObj[batch_no] ? that.batchCountObj[batch_no] : 0;
					let canUseNum = batch_number - hadUseNum;
					if (realWeight > canUseNum) {
						this.nowIndex = nowIndex;
						this.nowBatch_no = batch_no;
						canDo = false;
						if (!this.realCanDo) {
							this.showWarningBox = true;
						}
						// 提示是否切换库存分拣
						if (canUseBatchs.length < 1) {
							this.signType = 2;
							this.signText = "当前商品暂无任何批次的剩余库存数量满足本次分拣数量"
						} else {
							this.signType = 1;
							this.signText = "当前批次剩余库存数量无法本次分拣数量"
						}
					}
				}
				return canDo;
			},
			// 本批次依然分拣
			toStillDo() {
				this.realCanDo = true;
				this.showWarningBox = false;
				if (this.doType == 1) {
					this.toCreateSortTag(this.doWeight);
				} else {
					this.toCreateBatchSortTag();
				}
			},
			// 切换批次分拣
			toChangeDo(value) {
				this.$refs.batchNumberRef.toSelectSkuNumber(this.canUseBatchs[0].batch_no, this.canUseBatchs[0].index);
				if (value) {
					return
				}
				this.realCanDo = true;
				this.showWarningBox = false;
				if (this.doType == 1) {
					this.toCreateSortTag(this.doWeight);
				} else {
					this.toCreateBatchSortTag();
				}
			},
			// 无批次分拣
			toChooseNoneDo() {
				this.$refs.batchNumberRef.toSelectSkuNumber(this.nowBatch_no, this.nowIndex);
				this.realCanDo = true;
				this.showWarningBox = false;
				if (this.doType == 1) {
					this.toCreateSortTag(this.doWeight);
				} else {
					this.toCreateBatchSortTag();
				}
			},
			// 选择sku
			toSelect(item) {
				this.batchNoSelect = [];
				this.skuBatchNoList = [];
				this.currentSku = item;
				this.queryPreSortingBySku();
				this.openPicModal();
				// 计算SKU主辅单位转换关系
				this.formatShowSignValue();
			},
			formatShowSignValue() {
				this.showSignValue = '';
				if (!this.currentSku) {
					return
				}
        let countParams = {
          weightG:0,
          base_unit:this.currentSku.base_unit ? this.currentSku.base_unit : '',
          unit:this.currentSku.auxiliary_unit ? this.currentSku.auxiliary_unit : '',
          unit_conversion: this.currentSku.unit_conversion,
          is_weight:this.currentSku.is_weight
        }
       let result = getHasSortingUnitAndBaseUnit({...countParams})
       if(result.unit_conversion!=1){
        this.showSignValue = '1'+result.unit_tag+"等于"+result.unit_conversion+""+result.base_unit_tag;
       }else{
        this.showSignValue = ""
       }
			},
			// 打开更多筛选窗口
			showSearch() {
				this.$refs.search.showSearchModal();
			},
			// 打开数字键盘
			showKeyboard(value) {
				this.keyBorderValue = value;
				let data = JSON.parse(JSON.stringify(this.currentSku));
        data.product_cache = data.default_attribute || {};
				data.product_cache.specifications = data.auxiliary_unit;
				this.$refs.keyboard.showKeyboardModal(data);
			},
			showKeyboardTwo(data, index) {
				this.$refs.keyboard2.showKeyboardModal({});
			},
			// 查询sku
			querySkuCategory() {
				querySkuCategory({rows: 1000}).then(res => {
					if (res.status === 200) {
						this.skuCategoryList = res.data.data.rows;
					}
				});
			},
			// 查询sku
			queryPreSortingSku() {
				if (this.$store.state.preSortingType == 1) {
					let param = {...this.searchParams};
					queryPreSortingSkuType1(param).then(res => {
						if (res.status === 200) {
							this.skuList = res.data.data.rows;
							this.workbenchId = res.data.data.workbenchId;
							if (this.skuList.length) {
								this.currentSku = this.skuList[0];
								this.openPicModal();
								this.formatShowSignValue();
							}
							this.queryPreSortingBySku();
						}
					});
				} else {
					if (this.$store.state.sortingTimeSetting.sortingStartTime) {
						let param = {...this.searchParams};
						param.packTime = [
							this.$store.state.sortingTimeSetting.sortingStartTime,
							this.$store.state.sortingTimeSetting.sortingEndTime
						];
						queryPreSortingSkuType2(param).then(res => {
							if (res.status === 200) {
								this.skuList = res.data.data.rows;
								this.workbenchId = res.data.data.workbenchId;
								if (this.skuList.length) {
									this.currentSku = this.skuList[0];
									// this.queyPackWithId(this.currentSkuId);
									this.openPicModal();
									this.formatShowSignValue();
								}
								this.queryPreSortingBySku();
							}
						});
					}
				}
			},
			// 查询sku拣货数据
			queryPreSortingBySku() {
				if (!this.currentSku || !this.currentSku.sku_id) {
					this.loading = false;
					return
				}
				this.searchParams.groupSkuId = this.currentSku.groupSkuId;
				this.searchParams.packTime = [
					this.$store.state.sortingTimeSetting.sortingStartTime,
					this.$store.state.sortingTimeSetting.sortingEndTime
				];
				this.searchParams.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
				this.loading = true;
				let params = JSON.parse(JSON.stringify(this.searchParams));
				params.preSortingType = this.$store.state.preSortingType;
				params.skuId = this.currentSku.sku_id;
				if (this.nowSelectDate) {
					params.date = this.nowSelectDate;
				}
				queryPreSortingBySku(params).then(res => {
					if (res.status === 200) {
						if (res.data.data) {

              let countParams = {
                base_unit:this.currentSku.base_unit ? this.currentSku.base_unit : '',
                unit:this.currentSku.auxiliary_unit ? this.currentSku.auxiliary_unit : '',
                unit_conversion: this.currentSku.unit_conversion,
                is_weight:this.currentSku.is_weight
              }
			  res.data.data.all_pack_weight = res.data.data.all_pack_weight || 0;
			  res.data.data.all_pack_count = res.data.data.all_pack_count || 0;
							if (this.currentSku.is_weight == 1) {
								res.data.data.allNeedPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.all_pack_weight,...countParams}).showUnit
                res.data.data.allHadPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.all_weight,...countParams}).showUnit
                res.data.data.sortPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.sorting_weight,...countParams}).showUnit
                res.data.data.waitSortPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.wait_sorting_weight,...countParams}).showUnit
							} else {
                res.data.data.allNeedPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.all_pack_count,...countParams}).showUnit
                res.data.data.allHadPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.all_count,...countParams}).showUnit
                res.data.data.sortPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.sorting_count,...countParams}).showUnit
                res.data.data.waitSortPackNumber = getHasSortingUnitAndBaseUnit({weightG:res.data.data.wait_sorting_count,...countParams}).showUnit
							}

							this.preSortingData = res.data.data;
							if (res.data.data.datas && res.data.data.datas.length) {
								res.data.data.datas.forEach(item => {
									if (this.currentSku.is_weight == 1) {
										item.showUnitNumer = getHasSortingUnitAndBaseUnit({weightG:item.weight,...countParams}).showUnit
									} else {
                    item.showUnitNumer = getHasSortingUnitAndBaseUnit({weightG:item.pack_count,...countParams}).showUnit
									}
								})
							}
							this.tagsList = res.data.data.datas;
							this.countBatchCount();
							if (this.$store.state.platform_setting && this.$store.state.platform_setting.moduleArr.includes("traceSource")) {
								this.$refs.batchNumberRef.querySkuBatchNos(params.skuId, this.batchNoSelect[0]);
							}
						}
						this.loading = false;
					}
				});
			},
			// 接收搜索数据
			reciveSearchData(data) {
				this.queryPreSortingSku();
			},
			// 接收称重数据
			reciveData(data) {
				if (this.currentSku.is_weight == 1) {
          // 根据设置的称重单位将电子秤读数转化为当前sku的基本重量
          let unitValue = localStorage.getItem('unitValue') ? localStorage.getItem('unitValue') : 1
          let basicUnit = (unitValue == 1?'斤':'kg')
					// this.currentWeightData = Number(data.data);
					this.currentWeightData = changeUnit(data.data, basicUnit, this.currentSku.base_unit)
					this.reciveWeightComplete = true;
				}
			},
			// 接收数字键盘数据
			reciveKeyboardData(data) {
        //手工定重
				if (this.keyBorderValue == 1) {
					this.toCreateSortTag(Number(data.data));
				} else {
          //批量生成
					this.formValidate.weight = Number(data.data);
				}
				// this.currentWeightData = Number(data.data);
			},
			reciveKeyboardDataTwo(data) {
				this.formValidate.number = Number(data.data);
			},
			// 开启图片拣货
			changeOpenSkuCover(event) {
				localStorage.setItem("openPic", event);
				this.openPicModal();
			},
			openPicModal() {
				if (this.openPic) {
					setTimeout(() => {
						this.$refs.picModal.showCover(this.currentSku.groupSkuId);
					}, 300);
				}
			},
			// 检索sku名称
			searchSkuNameCallback(value) {
				this.searchSkuList = [];
				for (let i = 0; i < this.skuList.length; i++) {
					if (this.skuList[i].sku_name.includes(value)) {
						this.searchSkuList.push(this.skuList[i]);
					}
				}
			},
			// 选择SKU分类回调
			searchSkuCategoryCallback(event) {
				this.searchParams.skuCategoryId = event;
				this.queryPreSortingSku();
			},
			// 选中检索sku
			selectSkuNameCallback(event) {
				for (let i = 0; i < this.searchSkuList.length; i++) {
					if (event == this.searchSkuList[i].sku_name) {
						this.currentSku = this.searchSkuList[i];
            document.getElementById('text' + this.searchSkuList[i].sku_id).scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
						this.queryPreSortingBySku();
						this.openPicModal();
					}
				}
			},
			// 查询配送路线
			queryCarLine() {
				return new Promise((resolve, reject) => {
					queryCarLine().then(res => {
						if (res.status === 200) {
							this.carLine = res.data.data;
						}
					});
				}).catch(err => {
					console.log(err);
					this.$Message.error(err);
				});
			},
			// 查询sku预分拣记录明细(参考销售情况)
			queryPreSortingDetailBySku() {
				if (!this.currentSku || !this.currentSku.sku_id) {
					return
				}
				this.searchParams.groupSkuId = this.currentSku.groupSkuId;
				this.searchParams.packTime = [
					this.$store.state.sortingTimeSetting.sortingStartTime,
					this.$store.state.sortingTimeSetting.sortingEndTime
				];
				this.searchParams.spuCategoryIds = this.$store.state.sortingTimeSetting.spuCategoryIds;
				let params = JSON.parse(JSON.stringify(this.searchParams));
				params.preSortingType = this.$store.state.preSortingType;
				params.skuId = this.currentSku.sku_id;
				if (this.nowSelectDate) {
					params.date = this.nowSelectDate;
				}
				this.$refs.preSortingDetail.showDrawer(params, this.currentSku);
			},
		},
		watch: {
			"$store.state.storeComplete"(to, old) {
				this.searchParams.dateType = this.$store.state.dateType;
				this.searchParams.packTime = [
					this.$store.state.sortingTimeSetting.sortingStartTime,
					this.$store.state.sortingTimeSetting.sortingEndTime
				];
				this.queryPreSortingSku();
			}
		},
		// 进入页面激活组件
		activated() {
			if (this.$store.state.storeComplete) {
				this.queryPreSortingBySku();
        this.$refs.weightReading.showUnitValue();
			}
		},
		created() {
			this.nowSelectDate = timeUtil.dateFormat(new Date(), "YYYY-MM-DD");
			this.showNowSelectDate = timeUtil.dateFormat(new Date(), "M月DD日");
			// this.initWeightCommpont = true;
			if (this.$store.state.storeComplete) {
				this.queryPreSortingSku();
			}
			this.querySkuCategory();
			this.queryCarLine();
			let openPic = localStorage.getItem("openPic");
			if (openPic) {
				this.openPic = openPic == "true" ? true : false;
			}
		}
	};
</script>

<style scoped lang="less">
	.conentTop {
		width: 100%;
		display: flex;
		align-items: center;

		.weightBox {
			width: 360px;
			height: 140px;
			display: flex;
			align-items: center;
			background-color: #999;
			justify-content: space-between;
			box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);

			.weightleft {
				padding: 10px;
				height: 100%;
				width: 270px;
				display: flex;
				justify-content: center;
				flex-direction: column;
				box-sizing: border-box;

				.weightTitle {
					height: 30px;
					font-size: 22px;
					color: #ffffff;
					font-weight: bold;
					letter-spacing: 2px;
				}

				.weightValue {
					width: 100%;
					height: 100%;
					display: flex;
					color: #fff;
					font-size: 46px;
					font-weight: 500;
					align-items: center;
					padding-bottom: 10px;
					box-sizing: border-box;
					justify-content: center;
				}

				.signValue {
					color: #FFF;
					text-align: center;
				}
			}

			.weightright {
				width: 120px;
				height: 100%;
				display: flex;
				font-size: 34px;
				font-weight: 400;
				align-items: center;
				cursor: pointer;
				justify-content: center;
				background-color: #ffffff;
			}
		}

		.operationBox {
			height: 100%;
			display: flex;
			padding-left: 20px;
			box-sizing: border-box;
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-between;

			.operationButton {
				color: #ffffff;
				height: 60px;
				display: flex;
				cursor: pointer;
				padding: 10px 30px;
				border-radius: 4px;
				align-items: center;
				background: #4c70db;
				justify-content: center;
			}
		}
	}

	.dataInfoBox {
		width: 100%;
		height: 50px;
		display: flex;
		margin: 10px 0;
		padding: 10px;
		box-sizing: border-box;
		background-color: #fff;

		.dataInfo {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.tabItems {
		width: 100%;
		height: calc(78vh - 180px);
		overflow: hidden;
		overflow-y: scroll;

		&.short {
			height: calc(78vh - 275px);
		}

		.tabItem {
			width: 100%;
			min-height: 140px;
			padding-right: 20px;
			box-sizing: border-box;

			.itemBox {
				width: 100%;
				height: 100%;
				display: flex;
				color: #ffffff;
				justify-content: space-between;
				background-color: rgb(102, 153, 51);

				&.hadBind {
					background-color: rgb(102, 153, 204);
				}

				.itemLeft {
					padding: 10px;
					flex-grow: 1;
					box-sizing: border-box;

					.itemCode {
						font-size: 15px;
					}

					.itemValue {
						width: 100%;
						height: 78px;
						display: flex;
						font-size: 26px;
						font-weight: bold;
						align-items: center;
						justify-content: center;
					}

					.itemStatus {
						font-size: 14px;
					}
				}

				.itemRight {
					width: 70px;
					display: flex;
					color: #333333;
					flex-direction: column;
					justify-content: center;
					background-color: #ffffff;

					.operationButton {
						flex: 1;
						display: flex;
						cursor: pointer;
						align-items: center;
						justify-content: center;
						border: 1px solid #dedede;
					}
				}
			}
		}
	}

	.tabItems::-webkit-scrollbar {
		width: 30px;
		height: 100%;
		overflow: hidden;
		background-color: #f0faff;
	}

	.tabItems::-webkit-scrollbar-thumb {
		border-radius: 6px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		background-color: #666666;
	}

	.usePageBox {
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding-top: 50px;
		position: relative;
		box-sizing: border-box;
		// 新的数据
		.topBox {
			top: 0;
			left: 0;
			width: 100%;
			height: 50px;
			display: flex;
			padding: 0 10px;
			position: absolute;
			align-items: flex-start;

			.leftBox {
				width: 240px;
				margin-right: 10px;
			}

			.rightBox {
				flex-grow: 1;
				display: flex;
				padding-left: 20px;
				align-items: center;
				box-sizing: border-box;
				justify-content: space-between;
			}
		}

		.contentBox {
			width: 100%;
			height: 100%;
			display: flex;

			.leftBox {
				width: 240px;
			}

			.rightBox {
				flex-grow: 1;
				padding: 0 20px;
				overflow: hidden;
				overflow-y: scroll;
				box-sizing: border-box;
			}
		}
	}

	.skuBoxArea {
		scrollbar-width: none; /* firefox */
		-ms-overflow-style: none; /* IE 10+ */
		overflow-x: hidden;
		overflow-y: auto;
	}

	.skuBoxArea::-webkit-scrollbar {
		display: none;
		height: 100%;
		// background-color: #17233d;
	}

	.skuBox {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
		box-sizing: border-box;
		background-color: #17233d;
	}

	.skuBox::-webkit-scrollbar {
		width: 30px;
		height: 100%;
		background-color: #f0faff;
	}

	.skuBox::-webkit-scrollbar-thumb {
		border-radius: 6px;
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		background-color: #666666;
	}

	.skuItem {
		width: 100%;
		display: flex;
		min-height: 60px;
		color: #f0f0f0;
		padding: 5px 8px;
		align-items: center;
		justify-content: flex-start;

		&:hover {
			color: #f0f0f0;
			background-color: #21345c !important;
		}

		&.active {
			color: #595959;
			border-left: 6px solid #4c70db;
			background-color: #f0faff !important;
		}
	}

	.countNum {
		display: inline-block;
		margin-left: 6px;
		height: 100%;

		.numtext {
			display: flex;
			height: 20px;
			font-size: 18px;
			line-height: 18px;
			color: #ffffff;
			min-width: 27px;
			border-radius: 4px;
			align-items: center;
			justify-content: center;
			background-color: #fb4747;
		}
	}

	.batchCreateBox {
		width: 100%;

		.bottomBox {
			width: 100%;
			display: flex;
			height: 50px;
			margin-top: 50px;
			align-items: center;
			justify-content: space-around;

			.bottomButton {
				width: 200px;
				height: 100%;
				display: flex;
				border-radius: 4px;
				align-items: center;
				justify-content: center;
				border: 1px solid #dedede;

				&.mk {
					color: #fff;
					border: 1px solid #19be6b;
					background-color: #19be6b;
				}
			}
		}
	}

	.footerButton {
		height: 50px;
		padding: 20px;
		margin-left: 6px;
		border-radius: 2px;
		font-weight: bold;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		border: 1px solid #dedede;

		&.waring {
			color: #FFF;
			background-color: #ff9900;
		}

		&.success {
			color: #FFF;
			background-color: #4c70db;
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/sorting/preSorting.vue